import { render, staticRenderFns } from "./DiscountLandingPage.vue?vue&type=template&id=dc920906&scoped=true&"
import script from "./DiscountLandingPage.vue?vue&type=script&lang=js&"
export * from "./DiscountLandingPage.vue?vue&type=script&lang=js&"
import style0 from "./DiscountLandingPage.vue?vue&type=style&index=0&id=dc920906&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc920906",
  null
  
)

export default component.exports